import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Loss from "src/views/Pages/Dashboard/Grow/Reports/Loss/Loss.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const LossRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'lossreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.loss',
          component: Loss,
          meta: {
            prefix_permission: 'grow_loss',
          },
        },
      ],
    },
  ],
};

export default LossRoutes;
